/** Inline error banner with an optional retry action. */
export function ErrorBanner({ message, onRetry }) {
  if (!message) return null;
  return (
    <section
      className="card-shell flex flex-col gap-3 border border-umb-error/20 bg-umb-error/[0.05] p-4 text-sm text-umb-error sm:flex-row sm:items-center sm:justify-between"
      role="alert"
    >
      <span>{message}</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex shrink-0 items-center justify-center rounded-full border border-umb-error/30 bg-white px-3 py-1.5 text-xs font-semibold text-umb-error transition-colors hover:bg-umb-error/[0.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-umb-error/30 focus-visible:ring-offset-2"
        >
          Retry
        </button>
      ) : null}
    </section>
  );
}
